<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-row>
          <el-col :span="12" class="label-val">
            <span class="label">货主姓名：</span>
            <span class="value">{{ form.username }}</span>
          </el-col>
          <el-col :span="12" class="label-val">
            <span class="label">联系电话：</span>
            <span class="value">{{ form.phone }}</span>
          </el-col>
          <el-col :span="12" class="label-val">
            <span class="label">客户归属：</span>
            <span class="value"
              >{{ form.companyName }}
              <span v-if="form.inviterName">/{{ form.inviterName }}</span>
            </span>
          </el-col>
          <el-col :span="12" class="label-val">
            <span class="label">注册时间：</span>
            <span class="value">{{ form.registerTime }}</span>
          </el-col>
        </el-row>
        <div class="title-box">
          <el-image :src="cheImage" class="title-label"></el-image>修改归属
        </div>
        <el-row :gutter="20">
          <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-col :span="12">
              <el-form-item label="所属机构：" prop="companyId">
                <el-select
                  style="width: 100%"
                  clearable
                  v-model="form.companyId"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in companyData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="司机：" prop="driverUserId">
                <el-select
                  style="width: 100%"
                  clearable
                  v-model="form.driverUserId"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in driverUserData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { validatePhone } from "@/utils/validate";
import { addInfo, editInfo, setReal, updateBelong } from "./api";
import { getRoleSelect } from "@/views/commonApi";
import { userSms } from "@/views/login/api";
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  props: {
    companyData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      cheImage: require("@/assets/imgs/title.png"),
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "修改客户归属",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        companyId: "",
        driverUserId: "",
        ownerId: "",
      },
      rules: {
        companyId: [{ required: true, message: "所属机构不能为空" }],
        // realPhone: [{ required: true, message: "设备位置信息不能为空" }],
      },
      driverUserData: [],
    };
  },
  mounted() {},
  methods: {
    init(row) {
      if (!!row) {
        this.form = Object.assign({}, row);
      }
      this.dialogObj.show = true;
    },

    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          const par = {
            companyId: this.form.companyId,
            driverUserId: this.form.driverUserId,
            ownerId: this.form.ownerId,
          };
          updateBelong(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("设置成功");
                this.$parent.handleAddOrEditSuccess("edit");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .label-val {
    margin-bottom: 0.16rem;
  }
  .title-box {
    padding: 0rem 0 0.1rem;
    color: #000000;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
}
</style>
